import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TPrpApi } from './types';

export const prp: TPrpApi = {
	getSettings: (payload) =>
		http.get(endpoint.prp.GET_SETTINGS(payload.emId)).then((response) => response.data),
	updateSettings: (payload) =>
		http
			.put(endpoint.prp.UPDATE_SETTINGS(payload.emId), payload.body)
			.then((response) => response.data),
	activate: (payload) =>
		http.post(endpoint.prp.ACTIVATE(payload.emId), payload.body).then((response) => response.data),
	getPostalOperatorSettings: (payload) =>
		http
			.post(endpoint.prp.POSTAL_OPERATOR_SETTINGS_LIST(payload.emId), payload.body)
			.then((response) => response.data),
	updatePostalOperatorSettings: (payload) =>
		http
			.put(endpoint.prp.UPDATE_POSTAL_OPERATOR_SETTINGS(payload.emId, payload.id), payload.body)
			.then((response) => response.data),
};
